import * as Yup from 'yup';
import { PHONE_REGEX } from '../../shared/constants/regex';
import { CONTACT_METHOD_TYPE } from '../constants/addPersonFormConstants';

const personContactSchema = Yup.object({
  ContactType: Yup.string()
    .nullable()
    .when('ContactMethodType', {
      is: (value) => Boolean(value),
      then: (schema) => schema.required('Contact Type is required'),
    }),

  ContactInfo: Yup.string()
    .nullable()
    .max(100, 'Info cannot exceed 100 characters')
    .when('ContactMethodType', {
      is: CONTACT_METHOD_TYPE.PHONE,
      then: (schema) =>
        schema.test('phone-format', 'Invalid phone number', (value) => {
          if (!value) return true;
          return PHONE_REGEX.test(value);
        }),
    })
    .when('ContactMethodType', {
      is: CONTACT_METHOD_TYPE.EMAIL,
      then: (schema) => schema.email('Invalid email address'),
    }),

  ContactNotes: Yup.string().nullable().max(5000, 'Notes cannot exceed 5000 characters'),
});

export default personContactSchema;
